import {Box, Button, Container, Drawer, IconButton, Paper, Stack, styled, useMediaQuery} from "@mui/material";
import {ExitToAppRounded, MenuRounded} from "@mui/icons-material";
import Navigation from "./navigation";
import {useEffect, useRef, useState} from "react";
import {Link, useNavigate} from "react-router-dom";
import LoginModal from "./loginModal";
import {useUser} from "../../lib/hooks";
import useThemeStore from "../../store/theme";
import ConfirmDialog from "./confirmDialog";
import useMainStore from "../../store";

const Wrapper = styled(Box)(({theme}) => ({
    padding: "8px 0",
    "&.Mui-sticky": {
        "@keyframes fadeInDown": {
            "from": {
                opacity: 0,
                transform: 'translate3d(0, -100%, 0)',
            },
            "to": {
                opacity: 1,
                transform: "translate3d(0, 0, 0)",
            },
        },
        backgroundColor: theme.palette.background.box,
        boxShadow: "0 0 5.5px -1px rgb(33 33 33 / 5.5%)",
        position: "sticky",
        top: 0,
        zIndex: 100,
        animation: "fadeInDown .5s",
    }
}));

const Header = () => {

    const user = useUser();
    const isMobile = useMediaQuery(theme => theme.breakpoints.down('lg'));
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const [loginModalOpen, setLoginModalOpen] = useState(false);
    const [logoutConfirm, setLogoutConfirm] = useState(false);
    const navigate = useNavigate();

    const [isSticky, setIsSticky] = useState(false);
    const headerRef = useRef(null);
    const themeMode = useThemeStore(state => state.mode);

    useEffect(() => {
        function onScroll() {
            if (isMobile) return;
            if (!headerRef?.current) return;
            const headerOffsetTop = headerRef.current.offsetTop;
            if (window.pageYOffset >= headerOffsetTop) {
                const scTop = window.pageYOffset || document.documentElement.scrollTop;
                if (scTop >= 750) {
                    if (isSticky) return;
                    setIsSticky(true);
                } else {
                    if (!isSticky) return;
                    setIsSticky(false);
                }
            }
        }
        window.addEventListener('scroll', onScroll);
        return () => {
            window.removeEventListener('scroll', onScroll);
        }
    }, [isMobile, isSticky]);

    return (
        <>
            <Wrapper component="header" className={isSticky || isMobile ? "Mui-sticky" : ""} ref={headerRef}>
                <Container>
                    <Stack direction="row" alignItems="center" justifyContent={{lg: "space-between"}} spacing={2.5}>
                        <IconButton onClick={() => setMobileMenuOpen(true)} color="primary" sx={{ display: {xs: "flex", lg: "none"} }}>
                            <MenuRounded fontSize="large"/>
                        </IconButton>
                        <Link to="/">
                            <Box component="img" src={themeMode === 'light' ? "/assets/image/logo/mailfa.png" : "/assets/image/logo/mailfa-white.png"} width={128} height={32} sx={{ objectFit: "contain" }}/>
                        </Link>
                        <Navigation onLoginBtnClick={() => setLoginModalOpen(true)} onLogoutBtnClick={() => setLogoutConfirm(true)} sx={{ display: {xs: "none", lg: "flex"}, alignItems: "center" }}/>
                    </Stack>
                </Container>
            </Wrapper>
            {/* Mobile Menu */}
            <Drawer open={mobileMenuOpen} onClose={() => setMobileMenuOpen(false)} sx={{display: {lg: "none"} }} PaperProps={{ sx: {p: 2.5, width: "80%", justifyContent: "space-between"} }}>
                <Navigation
                    onLoginBtnClick={() => setLoginModalOpen(true)}
                    navItemProps={{ onClick: () => setMobileMenuOpen(false) }}
                    sx={{ display: "flex", flexDirection: "column", "& .MuiListItem-root:last-of-type": {order: -1, mb: 2, display: "flex", alignItems: "center", justifyContent: "center"}}}/>
                {user && (
                    <Button onClick={() => setLogoutConfirm(true)} fullWidth color="error" startIcon={<ExitToAppRounded/>}>خروج از حساب</Button>
                )}
            </Drawer>
            {/* Login Modal */}
            <LoginModal open={loginModalOpen} onClose={() => setLoginModalOpen(false)}/>
            {/* Logout Confirm */}
            <ConfirmDialog
                open={logoutConfirm}
                onClose={() => setLogoutConfirm(false)}
                color="error"
                title="مطعنی می خوای از حسابت خارج بشی؟!"
                onConfirm={() => {navigate("/logout", {replace: true}); setLogoutConfirm(false)}}/>
        </>
    )
}
export default Header;